import React, { Component } from "react";
import styles from "./routesSwitcher.module.scss";
import { FormControl, Radio } from "@mui/material";
import { NavLink } from "react-router-dom";
import { withRoutes } from "../../../shared/containers/containerRoutes";

class RoutesSwitcher extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checkControlPoints: window.location.pathname.includes("/controlPoints"),
    };
  }

  componentDidUpdate(prevProps) {
    const { checkControlPoints } = this.state;

    if (window.location.pathname.includes("/controlPoints") !== checkControlPoints) {
      this.setState({ checkControlPoints: window.location.pathname.includes("/controlPoints") });
    }
  }

  onClickHandle(e) {
    const { checkControlPoints } = this.state;

    if (window.location.pathname.includes("/controlPoints") !== checkControlPoints) {
      this.setState({ checkControlPoints: window.location.pathname.includes("/controlPoints") });
    }
  }

  render() {
    const { selectedRouteId } = this.props;
    const { checkControlPoints } = this.state;
    const id = selectedRouteId === null ? "" : selectedRouteId + "/";

    return (
      <FormControl onClick={this.onClickHandle.bind(this)}>
        <div className={styles.radioButtomContainer}>
          <div>
            <NavLink to={`/routes/${id}controlPoints`} className={styles.navigationItem} activeClassName={styles.navigationItem_active}>
              <Radio checked={checkControlPoints} size="small" />
              Контрольные точки
            </NavLink>
          </div>
          <div>
            <NavLink to={`/routes/${id}trips`} className={styles.navigationItem} activeClassName={styles.navigationItem_active}>
              <Radio checked={!checkControlPoints} size="small" />
              Рейсы
            </NavLink>
          </div>
        </div>
      </FormControl>
    );
  }
}

export default withRoutes(React.memo(RoutesSwitcher));
